import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";

export function ProtectedRoute({ requireRole }: { requireRole?: "AGENT" | "CONSUMER" }) {
  const user = useAuthStore((s) => s.user);
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const location = useLocation();

  if (!isInitialized) {
    return <div className="container-page py-20 text-center text-steel-600">Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/account/login" state={{ redirectTo: location.pathname }} replace />;
  }

  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
